
/* styles */
require("!!../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-2110c524&scoped=true!./partner-information-modal.scss")

var Component = require("!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./partner-information-modal.js"),
  /* template */
  require("!!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-2110c524!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./partner-information-modal.vue"),
  /* scopeId */
  "data-v-2110c524",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/partner-information/partner-information-modal.vue
// module id = 1885
// module chunks = 1